import { CircularProgress } from "./CiruculaProgress";

interface ScoreDisplayProps {
  score: number;
  size?: "sm" | "md" | "lg";
}

export function ScoreDisplay({ score, size = "md" }: ScoreDisplayProps) {
  return (
    <div className="flex flex-col items-center gap-3 w-full">
      <CircularProgress score={score} size={size} showLabels={false} />
    </div>
  );
}
